import styled from 'styled-components';

export const PhoneConfirmationWrapper = styled.div`
    display: flex;
    flex-grow: 1;
    flex-direction: column;
    margin: -8px -16px 0px -16px;

    ${({ theme }) => theme.superQuery.all.and.maxWidth.mobileMax.css`
        margin: 0px -16px;
     `};
`;
